function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command, Plugin, icons } from '@ckeditor/ckeditor5-core/dist/index.js';
import { first } from '@ckeditor/ckeditor5-utils/dist/index.js';
import { ButtonView } from '@ckeditor/ckeditor5-ui/dist/index.js';
/**
 * The paragraph command.
 */

var ParagraphCommand = /*#__PURE__*/function (_Command) {
  _inherits(ParagraphCommand, _Command);

  var _super = _createSuper(ParagraphCommand);

  function ParagraphCommand(editor) {
    var _this;

    _classCallCheck(this, ParagraphCommand);

    _this = _super.call(this, editor); // Since this command may pass selection in execution block, it should be checked directly.

    _this._isEnabledBasedOnSelection = false;
    return _this;
  }
  /**
  * @inheritDoc
  */


  _createClass(ParagraphCommand, [{
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var document = model.document;
      var block = first(document.selection.getSelectedBlocks());
      this.value = !!block && block.is('element', 'paragraph');
      this.isEnabled = !!block && checkCanBecomeParagraph(block, model.schema);
    }
    /**
    * Executes the command. All the blocks (see {@link module:engine/model/schema~Schema}) in the selection
    * will be turned to paragraphs.
    *
    * @fires execute
    * @param options Options for the executed command.
    * @param options.selection The selection that the command should be applied to. By default,
    * if not provided, the command is applied to the {@link module:engine/model/document~Document#selection}.
    */

  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var model = this.editor.model;
      var document = model.document;
      var selection = options.selection || document.selection; // Don't execute command if selection is in non-editable place.

      if (!model.canEditAt(selection)) {
        return;
      }

      model.change(function (writer) {
        var blocks = selection.getSelectedBlocks();

        var _iterator = _createForOfIteratorHelper(blocks),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var block = _step.value;

            if (!block.is('element', 'paragraph') && checkCanBecomeParagraph(block, model.schema)) {
              writer.rename(block, 'paragraph');
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      });
    }
  }]);

  return ParagraphCommand;
}(Command);
/**
 * Checks whether the given block can be replaced by a paragraph.
 *
 * @param block A block to be tested.
 * @param schema The schema of the document.
 */


function checkCanBecomeParagraph(block, schema) {
  return schema.checkChild(block.parent, 'paragraph') && !schema.isObject(block);
}
/**
 * The insert paragraph command. It inserts a new paragraph at a specific
 * {@link module:engine/model/position~Position document position}.
 *
 * ```ts
 * // Insert a new paragraph before an element in the document.
 * editor.execute( 'insertParagraph', {
 *   position: editor.model.createPositionBefore( element )
 * } );
 * ```
 *
 * If a paragraph is disallowed in the context of the specific position, the command
 * will attempt to split position ancestors to find a place where it is possible
 * to insert a paragraph.
 *
 * **Note**: This command moves the selection to the inserted paragraph.
 */


var InsertParagraphCommand = /*#__PURE__*/function (_Command2) {
  _inherits(InsertParagraphCommand, _Command2);

  var _super2 = _createSuper(InsertParagraphCommand);

  function InsertParagraphCommand(editor) {
    var _this2;

    _classCallCheck(this, InsertParagraphCommand);

    _this2 = _super2.call(this, editor); // Since this command passes position in execution block instead of selection, it should be checked directly.

    _this2._isEnabledBasedOnSelection = false;
    return _this2;
  }
  /**
  * Executes the command.
  *
  * @param options Options for the executed command.
  * @param options.position The model position at which the new paragraph will be inserted.
  * @param options.attributes Attributes keys and values to set on a inserted paragraph.
  * @fires execute
  */


  _createClass(InsertParagraphCommand, [{
    key: "execute",
    value: function execute(options) {
      var _this3 = this;

      var model = this.editor.model;
      var attributes = options.attributes;
      var position = options.position; // Don't execute command if position is in non-editable place.

      if (!model.canEditAt(position)) {
        return;
      }

      model.change(function (writer) {
        position = _this3._findPositionToInsertParagraph(position, writer);

        if (!position) {
          return;
        }

        var paragraph = writer.createElement('paragraph');

        if (attributes) {
          model.schema.setAllowedAttributes(paragraph, attributes, writer);
        }

        model.insertContent(paragraph, position);
        writer.setSelection(paragraph, 'in');
      });
    }
    /**
    * Returns the best position to insert a new paragraph.
    */

  }, {
    key: "_findPositionToInsertParagraph",
    value: function _findPositionToInsertParagraph(position, writer) {
      var model = this.editor.model;

      if (model.schema.checkChild(position, 'paragraph')) {
        return position;
      }

      var allowedParent = model.schema.findAllowedParent(position, 'paragraph'); // It could be there's no ancestor limit that would allow paragraph.
      // In theory, "paragraph" could be disallowed even in the "$root".

      if (!allowedParent) {
        return null;
      }

      var positionParent = position.parent;
      var isTextAllowed = model.schema.checkChild(positionParent, '$text'); // At empty $block or at the end of $block.
      // <paragraph>[]</paragraph> ---> <paragraph></paragraph><paragraph>[]</paragraph>
      // <paragraph>foo[]</paragraph> ---> <paragraph>foo</paragraph><paragraph>[]</paragraph>

      if (positionParent.isEmpty || isTextAllowed && position.isAtEnd) {
        return model.createPositionAfter(positionParent);
      } // At the start of $block with text.
      // <paragraph>[]foo</paragraph> ---> <paragraph>[]</paragraph><paragraph>foo</paragraph>


      if (!positionParent.isEmpty && isTextAllowed && position.isAtStart) {
        return model.createPositionBefore(positionParent);
      }

      return writer.split(position, allowedParent).position;
    }
  }]);

  return InsertParagraphCommand;
}(Command);
/**
 * The paragraph feature for the editor.
 *
 * It introduces the `<paragraph>` element in the model which renders as a `<p>` element in the DOM and data.
 *
 * It also brings two editors commands:
 *
 * * The {@link module:paragraph/paragraphcommand~ParagraphCommand `'paragraph'`} command that converts all
 * blocks in the model selection into paragraphs.
 * * The {@link module:paragraph/insertparagraphcommand~InsertParagraphCommand `'insertParagraph'`} command
 * that inserts a new paragraph at a specified location in the model.
 */


var Paragraph = /*#__PURE__*/function (_Plugin) {
  _inherits(Paragraph, _Plugin);

  var _super3 = _createSuper(Paragraph);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _super3.apply(this, arguments);
  }

  _createClass(Paragraph, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var editor = this.editor;
      var model = editor.model;
      editor.commands.add('paragraph', new ParagraphCommand(editor));
      editor.commands.add('insertParagraph', new InsertParagraphCommand(editor)); // Schema.

      model.schema.register('paragraph', {
        inheritAllFrom: '$block'
      });
      editor.conversion.elementToElement({
        model: 'paragraph',
        view: 'p'
      }); // Conversion for paragraph-like elements which has not been converted by any plugin.

      editor.conversion.for('upcast').elementToElement({
        model: function model(viewElement, _ref) {
          var writer = _ref.writer;

          if (!Paragraph.paragraphLikeElements.has(viewElement.name)) {
            return null;
          } // Do not auto-paragraph empty elements.


          if (viewElement.isEmpty) {
            return null;
          }

          return writer.createElement('paragraph');
        },
        view: /.+/,
        converterPriority: 'low'
      });
    }
    /**
    * A list of element names which should be treated by the autoparagraphing algorithms as
    * paragraph-like. This means that e.g. the following content:
    *
    * ```html
    * <h1>Foo</h1>
    * <table>
    *   <tr>
    *     <td>X</td>
    *     <td>
    *       <ul>
    *         <li>Y</li>
    *         <li>Z</li>
    *       </ul>
    *     </td>
    *   </tr>
    * </table>
    * ```
    *
    * contains five paragraph-like elements: `<h1>`, two `<td>`s and two `<li>`s.
    * Hence, if none of the features is going to convert those elements the above content will be automatically handled
    * by the paragraph feature and converted to:
    *
    * ```html
    * <p>Foo</p>
    * <p>X</p>
    * <p>Y</p>
    * <p>Z</p>
    * ```
    *
    * Note: The `<td>` containing two `<li>` elements was ignored as the innermost paragraph-like elements
    * have a priority upon conversion.
    */

  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'Paragraph';
    }
  }]);

  return Paragraph;
}(Plugin);
/**
 * This plugin defines the `'paragraph'` button. It can be used together with
 * {@link module:heading/headingbuttonsui~HeadingButtonsUI} to replace the standard heading dropdown.
 *
 * This plugin is not loaded automatically by the {@link module:paragraph/paragraph~Paragraph} plugin. It must
 * be added manually.
 *
 * ```ts
 * ClassicEditor
 *   .create( {
 *     plugins: [ ..., Heading, Paragraph, HeadingButtonsUI, ParagraphButtonUI ]
 *     toolbar: [ 'paragraph', 'heading1', 'heading2', 'heading3' ]
 *   } )
 *   .then( ... )
 *   .catch( ... );
 * ```
 */


Paragraph.paragraphLikeElements = new Set(['blockquote', 'dd', 'div', 'dt', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'li', 'p', 'td', 'th']);

var ParagraphButtonUI = /*#__PURE__*/function (_Plugin2) {
  _inherits(ParagraphButtonUI, _Plugin2);

  var _super4 = _createSuper(ParagraphButtonUI);

  function ParagraphButtonUI() {
    _classCallCheck(this, ParagraphButtonUI);

    return _super4.apply(this, arguments);
  }

  _createClass(ParagraphButtonUI, [{
    key: "init",
    value:
    /**
    * @inheritDoc
    */
    function init() {
      var editor = this.editor;
      var t = editor.t;
      editor.ui.componentFactory.add('paragraph', function (locale) {
        var view = new ButtonView(locale);
        var command = editor.commands.get('paragraph');
        view.label = t('Paragraph');
        view.icon = icons.paragraph;
        view.tooltip = true;
        view.isToggleable = true;
        view.bind('isEnabled').to(command);
        view.bind('isOn').to(command, 'value');
        view.on('execute', function () {
          editor.execute('paragraph');
        });
        return view;
      });
    }
  }], [{
    key: "requires",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return [Paragraph];
    }
  }]);

  return ParagraphButtonUI;
}(Plugin);

export { Paragraph, ParagraphButtonUI };